// @ts-nocheck
import { Entries } from 'src/types/general'

// Map key/value pairs to options array
type EnumObject<T> = {
  [key in keyof T]: keyof T
}

export function convertToOptions<T>(obj: T): { value: keyof T; label: string }[] {
  return Object.entries(obj as { [key: string]: any; label: string }).map(
    ([key, { label }]) =>
      ({
        value: key,
        label,
      } as { value: keyof T; label: string }),
  )
}

export function convertToEnum<T extends { [key: string]: any }>(obj: T): EnumObject<T> {
  const output = { ...obj }
  // @ts-ignore
  Object.keys(obj).forEach((key) => (output[key] = key))
  return output
}

export function buildLUTs<T extends { [key: string]: any }>(obj: T) {
  return {
    options: convertToOptions(obj),
    enum: convertToEnum<T>(obj),
    arr: Object.keys(obj) as (keyof T)[],
    entries: getEntries(obj),
  }
}

export const getEntries = <T extends object>(obj: T) => Object.entries(obj) as Entries<T>
